// Create a cache to store responses
const emailCache = new Map();

export const checkEmail = async (portalId, formId, email) => {
  // If the email is already in cache, return the stored data
  if (emailCache.has(email)) {
    //console.log(`Using cached data for ${email}`);
    return emailCache.get(email);
  }

  try {
    const response = await fetch(
      `https://forms.hsforms.com/emailcheck/v1/json-ext?hs_static_app=forms-embed&hs_static_app_version=1.7731&X-HubSpot-Static-App-Info=forms-embed-1.7731&portalId=${portalId}&formId=${formId}&includeFreemailSuggestions=false`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/xml",
        },
        body: email,
      }
    );

    const data = await response.json();
    //console.log(`Fetched`);

    // Cache the response to avoid duplicate requests
    emailCache.set(email, data);

    return data;
  } catch (error) {
    console.error("Error :", error);
    return null; // Return null in case of an error
  }
};


export const submit = async(portalId, formId, email) =>{
	const formData = {
    fields: [
        { name: "email", value: email }
    ]
  };

  try {
    const response = await fetch(
      `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData)
      }
    );

    const data = await response.json();
    //console.log(`Fetched`);

    // Cache the response to avoid duplicate requests
    //emailCache.set(email, data);

    return data;
  } catch (error) {
    console.error("Error :", error);
    return null; // Return null in case of an error
  }

  /*
  fetch("https://api.hsforms.com/submissions/v3/integration/submit/44252774/f53de43d-a3bf-4afd-9206-ff31bf2b396b", {
      method: "POST",
      headers: {
          "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
      console.log("Success:", data);
      alert("Form submitted successfully!");
  })
  .catch(error => {
      console.error("Error:", error);
      alert("There was an error submitting the form.");
  });
  */
}